const config = {
    rest: {     // REST API
        host: 'https://api72.voxytel.fr',
        root: '',
        route: (resource) => `${config.rest.host}${config.rest.root}/${resource}`,
    }
}

export default config